import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
function relative(ts) {
    const parsed = Date.parse(ts);
    if (Number.isNaN(parsed))
        return "—";
    const deltaMs = Date.now() - parsed;
    if (deltaMs < 60_000)
        return `${Math.max(1, Math.floor(deltaMs / 1000))}s ago`;
    if (deltaMs < 3_600_000)
        return `${Math.floor(deltaMs / 60_000)}m ago`;
    return `${Math.floor(deltaMs / 3_600_000)}h ago`;
}
function shortId(value, cap = 14) {
    if (!value)
        return "—";
    if (value.length <= cap)
        return value;
    return `${value.slice(0, cap - 1)}…`;
}
function statusLabel(m) {
    if (m.status === "matched")
        return "Matched";
    if (m.status === "spawned")
        return "Spawned";
    return "Failed";
}
const wrapStyle = {
    backgroundColor: "var(--color-pure-white)",
    color: "var(--color-deep-ink)",
    borderTop: "1px solid var(--color-pebble)",
    padding: "10px 22px 14px",
    fontFamily: "var(--font-display)",
};
const rowStyle = {
    display: "grid",
    gridTemplateColumns: "72px minmax(0, 1fr) 84px 90px",
    gap: 12,
    alignItems: "center",
    fontSize: 13,
    lineHeight: 1.4,
    padding: "6px 0",
    borderBottom: "1px solid var(--color-pebble)",
};
export function PhantomHistoryList({ matches, open, limit = 5, }) {
    if (!open)
        return null;
    const rows = matches.slice(0, limit);
    return (_jsxs("div", { style: wrapStyle, "data-testid": "phantom-history-list", role: "region", "aria-label": "Recent phantom bus events", children: [_jsxs("div", { style: {
                    fontSize: 12,
                    fontWeight: 700,
                    color: "var(--color-cool-ash)",
                    letterSpacing: "0.14em",
                    textTransform: "uppercase",
                    marginBottom: 6,
                }, children: ["Last ", rows.length || 0, " phantom event", rows.length === 1 ? "" : "s"] }), rows.length === 0 ? (_jsx("div", { style: {
                    fontSize: 14,
                    color: "var(--color-cool-ash)",
                    padding: "8px 0",
                }, children: "No phantom events yet. Trigger one from the alert rail or POST to /api/phantom/request." })) : (rows.map((m, idx) => {
                const actor = m.virtual_bus_id ?? m.matched_driver_id ?? "—";
                return (_jsxs("div", { style: {
                        ...rowStyle,
                        borderBottom: idx === rows.length - 1
                            ? "none"
                            : rowStyle.borderBottom,
                    }, "data-testid": `phantom-history-row-${idx}`, children: [_jsx("div", { style: {
                                fontSize: 12,
                                color: "var(--color-cool-ash)",
                                fontVariantNumeric: "tabular-nums",
                            }, children: relative(m.ts) }), _jsxs("div", { style: { minWidth: 0 }, children: [_jsx("div", { style: {
                                        fontWeight: 700,
                                        color: "var(--color-deep-ink)",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }, title: actor, children: shortId(actor, 18) }), _jsxs("div", { style: {
                                        fontSize: 12,
                                        color: "var(--color-cool-ash)",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }, title: `${m.trigger_stop_id} · ${m.waiting_pax} pax`, children: [shortId(m.trigger_stop_id, 18), " \u00B7 ", m.waiting_pax, " pax"] })] }), _jsxs("div", { style: {
                                fontSize: 12,
                                color: "var(--color-cool-ash)",
                                fontVariantNumeric: "tabular-nums",
                            }, children: [(m.spawn_latency_s * 1000).toFixed(1), "ms"] }), _jsx("div", { style: {
                                fontSize: 12,
                                fontWeight: 700,
                                color: m.status === "failed"
                                    ? "var(--color-cool-ash)"
                                    : "var(--color-deep-ink)",
                                textTransform: "uppercase",
                                letterSpacing: "0.08em",
                            }, children: statusLabel(m) })] }, `${m.id}-${idx}`));
            }))] }));
}
